import { render, staticRenderFns } from "./DatasetAttributes.vue?vue&type=template&id=56d7bb50&"
import script from "./DatasetAttributes.vue?vue&type=script&lang=js&"
export * from "./DatasetAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports